import { SvgIconComponent } from '@mui/icons-material'
import { ClickAwayListener, Tooltip } from '@mui/material'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import { ReactElement, useState } from 'react'
import { Button } from 'ui'

import style from './DesktopMobileTooltip.module.scss'

type TTooltip = {
  Icon: ReactElement<SvgIconComponent>
  title: string
}

// Тултип с информацией
export function DesktopMobileTooltip({ Icon, title }: TTooltip) {
  const screen = useScreen()
  const [open, setOpen] = useState(false)

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleTooltipOpen = () => {
    setOpen(true)
  }

  if (screen === ScreenEnum.desktop) {
    return (
      <Tooltip
        title={title}
        className={style.tooltip}
        disableInteractive
        describeChild
      >
        <Button startIcon={Icon} />
      </Tooltip>
    )
  }
  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          className={style.tooltip}
          title={title}
        >
          <Button onClick={handleTooltipOpen} startIcon={Icon} />
        </Tooltip>
      </div>
    </ClickAwayListener>
  )
}
